import { Tooltip, Badge } from '@mantine/core';
import { Cpu } from 'react-feather';

interface MatchingToolPillProps {
  /**
   * If true, render as a compact icon-only-style badge for tight row layouts.
   * If false (default), render a labeled badge for the group card header.
   */
  compact?: boolean;
}

const TOOLTIP_TEXT = 'This group was created by the matching tool.';

/**
 * "Matching Tool" provenance pill for groups whose `synced_by_matching_session_id`
 * is non-null. Indicates the group was last written by the matching-server
 * leg (E) callback (E23-11 / MED-926).
 *
 * Visually distinct from the destructive/warning `OverrideWarning` badge
 * (which uses `warningAmber` + filled). This pill is neutral/informational.
 */
export function MatchingToolPill({ compact = false }: MatchingToolPillProps) {
  if (compact) {
    return (
      <Tooltip label={TOOLTIP_TEXT} withArrow multiline w={260}>
        <Badge
          color="violet"
          variant="light"
          size="sm"
          leftSection={<Cpu size={12} />}
          aria-label="Matching Tool"
        >
          Matching Tool
        </Badge>
      </Tooltip>
    );
  }

  return (
    <Tooltip label={TOOLTIP_TEXT} withArrow multiline w={280}>
      <Badge
        color="violet"
        variant="light"
        size="lg"
        radius="xl"
        leftSection={<Cpu size={14} />}
        aria-label="Matching Tool"
        styles={{
          label: { fontWeight: 500, fontSize: 13, textTransform: 'none', letterSpacing: 0 },
        }}
      >
        Matching Tool
      </Badge>
    </Tooltip>
  );
}
